import { TenantRoles, } from 'modules/application/tenant/TenantService';
import { Contexts, } from 'modules/core/ContextProcessorService';
import { OnboardingFeatures } from './OnboardingFeatures';
import { ReasonCodes } from 'types/ReasonCodes';
import { LimeError } from 'modules/application/misc/LimeError';
const SIDEBAR_DISMISS_BUCKET_KEY = 'blip_portal:onboarding_sidebar_dismiss';
const SIDEBAR_PROGRESS_BUCKET_KEY = 'blip_portal:onboarding_sidebar_progress';
export class OnboardingService {
    static $inject = ['ContextProcessorService', 'TenantService', 'BlipBucketService', 'TranslateService'];
    constructor(ContextProcessorService, TenantService, BlipBucketService, TranslateService) {
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.BlipBucketService = BlipBucketService;
        this.TranslateService = TranslateService;
        this.isOnboardingSidebarVisible = false;
        this.onInit();
    }
    async onInit() {
        await this.ContextProcessorService.waitForInitialization();
        this.isOnboardingSidebarVisible = await OnboardingFeatures.isOnboardingSidebarVisible();
    }
    async shouldShowOnboardingSidebar(validateOnBucket = true) {
        if (!this.isOnboardingSidebarVisible || !this.isNewOrganization()) {
            return false;
        }
        const userLanguage = await this.TranslateService.getCurrentLanguage();
        if (userLanguage !== 'pt') {
            return false;
        }
        const tenantPlan = await this.TenantService.getTenantPlan(this.ContextProcessorService.tenant.id);
        if (tenantPlan.toLowerCase() === 'standard') {
            return false;
        }
        const isTenantAdmin = await this.TenantService.currentUserHasRequiredTenantRole(this.ContextProcessorService.tenant.id, [TenantRoles.Admin]);
        if (!isTenantAdmin) {
            return false;
        }
        if (validateOnBucket) {
            const response = await this.BlipBucketService.get(SIDEBAR_DISMISS_BUCKET_KEY);
            if (response.status === 'success' && response.resource === 'true') {
                return false;
            }
        }
        return true;
    }
    async revokeOnboardingSidebarDismiss() {
        const response = await this.BlipBucketService.delete(SIDEBAR_DISMISS_BUCKET_KEY);
        if (response.status === 'success') {
            dispatchEvent(new CustomEvent('onOnboardingSidebarUpdate'));
            return true;
        }
        if (response.reason.code === ReasonCodes.ResourceNotFound) {
            return true;
        }
        console.error('Could not revoke onboarding sidebar dismissing.', new LimeError({
            code: response.reason.code,
            description: response.reason.description,
        }));
        return false;
    }
    async getOnboardingSidebarProgress() {
        const response = await this.BlipBucketService.get(SIDEBAR_PROGRESS_BUCKET_KEY);
        if (response.status === 'success') {
            return Math.floor(parseFloat(response.resource));
        }
        return 0;
    }
    isNewOrganization() {
        const ORGANIZATION_LIFETIME_LIMIT = 3; // Months
        if (this.ContextProcessorService.context != Contexts.Tenants) {
            return false;
        }
        const tenantCreationDate = this.ContextProcessorService.tenant
            .creationDate;
        if (tenantCreationDate) {
            const dateLimit = new Date(Date.parse(tenantCreationDate.toString()));
            dateLimit.setMonth(dateLimit.getMonth() + ORGANIZATION_LIFETIME_LIMIT);
            if (new Date() < dateLimit) {
                return true;
            }
        }
        return false;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
OnboardingService.$inject = ['ContextProcessorService', 'TenantService', 'BlipBucketService', 'TranslateService'];
